import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import router from './router'
import store from './store/index'
import 'babel-polyfill'
import 'core-js'
Vue.config.productionTip = false
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
import 'lib-flexible'
import './style/common.css'
import './assets/styles/reset.css'
import './assets/styles/style.less'
import 'ant-design-vue/dist/antd.css'
import './style/theme.less'
import './Mobile/theme.less'
// 导航守卫
import './common/fuards/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.use(Antd)

router.beforeEach((to, from, next) => {
  // PC和移动端页面切换菜单后滚到顶部
  window.scrollTo(0, 0)
  next()
})

new Vue({
  router,
  store,
  el: '#app',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App)
}).$mount('#app')
